"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Wallet_1 = require("./Wallet");
exports.default = Wallet_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Wallet/index.js
// module id = 215
// module chunks = 0 1